import { Table, Thead, Tbody, Tr, Th, Td, Box, Link } from '@chakra-ui/react';

const PublicationTable = ({ data }: { data: any }) => {
  return (
    <Box overflowX="auto" p={4}>
      <Table variant="striped" colorScheme="gray">
        <Thead>
          <Tr>
            <Th fontWeight={900}>Sr No</Th>
            <Th fontWeight={900}>Publication</Th>
            <Th fontWeight={900}>Link</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((row: any, index: number) => (
            <Tr key={index}>
              <Td color="#46564A">{row.srNo}</Td>
              <Td color="#46564A">{row.publication}</Td>
              <Td>
                <Link
                  href={row.link}
                  color="#197542"
                  textDecoration="underline"
                  target="_blank" // Opens the link in a new tab
                  rel="noopener noreferrer" // Security best practice for external links
                >
                  {row.text}
                </Link>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};
export default PublicationTable;
